<template>
  <v-flex xs2>
    <v-select
      :items="graphicTypes"
      v-model="tmp"
      color="grey"
      solo>
    </v-select>
  </v-flex>
</template>

<script>
import _ from 'lodash';
import EventBus from '@/event-bus';

export default {
  props: {
    graphicType: {
      type: String,
      required: true,
    },
  },
  created() {
    EventBus.$on(`show${_.upperFirst(this.graphicType)}`, () => {
      this.tmp = this.graphicType;
    });
  },
  destroyed() {
    EventBus.$off(`show${_.upperFirst(this.graphicType)}`);
  },
  data() {
    return {
      tmp: this.graphicType,
      graphicTypes: [
        {
          value: 'totalGraphic',
          text: 'Total',
        },
        {
          value: 'historicGraphic',
          text: 'Historica',
        },
      ],
    };
  },
  watch: {
    tmp(newVal) {
      if (newVal !== this.graphicType) {
        EventBus.$emit('graphicTypeChanged', newVal);
        EventBus.$emit(`show${_.upperFirst(newVal)}`);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/panel/management/GraphicTypes.vue